export const SET_SELECTED_TAB = "SET_SELECTED_TAB";
export const GET_SELECTED_TAB = "GET_SELECTED_TAB";
export const CLEAR_SELECTED_TAB = "CLEAR_SELECTED_TAB";
